/**
* Focus first item in dropdown
*
* @param {Element} dropdown
*/

export function focusFirstItemIn(dropdown) {
    const firstItem = dropdown.querySelector('li > .prom-dropdown__listitem');

    // @ts-ignore
    firstItem.focus();
}

/**
* Focus last item in dropdown
*
* @param {Element} dropdown
*/
export function focusLastItemIn(dropdown) {
    const lastItem = dropdown.children[dropdown.children.length - 1];

    // @ts-ignore
    lastItem.querySelector('.prom-dropdown__listitem').focus();
}

/**
 * Return focus to the parent dropdown when closing a submenu
 *
 */
export function returnFocusToParentDropdown() {
    const button = document.querySelector('.prom-dropdown__listitems-menu.open');

    if (button) {
        // @ts-ignore
        button.focus();
        removeFocusFromParentDropdown();
    }
}

export function removeFocusFromParentDropdown() {
    const button = document.querySelector('.prom-dropdown__listitems-menu.open');

    if (button) {
        button.classList.remove('open');
    }
}

/**
* Hide dropdown
*
* @param {HTMLElement} submenu
*/
export function hide(submenu) {
    submenu.setAttribute('hidden', 'hidden');
}

/**
* Is submenu hidden?
*
* @param {HTMLElement} submenu
* @returns {boolean}
*/
export function hidden(submenu) {
    return submenu && submenu.hasAttribute('hidden');
}

/**
 * Hide open submenus
 *
 */
export function hideOpenSubmenus() {
    const submenus = Array.prototype.slice.call(document.querySelectorAll('.prom-dropdown__submenu'));

    for (let i = 0; i < submenus.length; i++) {
        hide(submenus[i]);
    }

    const menuButtons = document.querySelectorAll('.prom-dropdown__listitems-menu');

    for (let i = 0; i < menuButtons.length; i++) {
        menuButtons[i].setAttribute('aria-expanded', 'false');
    }
}

/**
* Show submenu
*
* @param {HTMLElement} submenu
*/
export function show(submenu) {
    submenu.style.right = null;
    submenu.style.left = null;
    submenu.style.top = null;

    if (window.innerWidth > 480) {
        const openerRect = submenu.parentElement.getBoundingClientRect();
        const dropdownBody = getClosestParentByClass(submenu, 'prom-dropdown__body');

        // If there is space to the right open there, otherwise open to the left
        if (window.innerWidth - openerRect.right >= openerRect.width) {
            submenu.style.left = openerRect.width + 'px';
        } else {
            submenu.style.right = openerRect.width + 'px';
        }

        // Set the submenu's top style to line up with the element that opened it
        submenu.style.top = openerRect.top - dropdownBody.getBoundingClientRect().top - 5 + 'px';
    }

    submenu.removeAttribute('hidden');
}

function getClosestParentByClass(element, matchClass) {
    while (element.parentElement !== null) {
        element = element.parentElement;

        if (element.classList.contains(matchClass)) {
            return element;
        }
    }

    return null;
}

/**
 * Are there any open submenus?
 *
 * @returns {boolean} True if open submenus
 */
export function openSubmenus() {
    const submenus = document.querySelectorAll('.prom-dropdown__submenu');

    let open = false;

    if (submenus.length > 0) {
        submenus.forEach((submenu) => {
            if (submenu.hasAttribute('aria-expanded')) {
                const expanded = submenu.getAttribute('aria-expanded');

                if (expanded === 'true') {
                    open = true;
                }
            }
        });
    }

    return open;
}

export function isMenuItem(button) {
    return button.classList.contains('prom-dropdown__listitems-menu');
}
